export const transferableState = {
  encode: (state) => {
    if (!state) return null;
    return btoa(unescape(encodeURIComponent(JSON.stringify(state))));
  },
  decode: (state) => {
    if (!state) return null;
    return JSON.parse(decodeURIComponent(escape(atob(state))));
  },
};
